export default __webpack_public_path__ + "static/victoria-video-ac02e9487d8b548198b4fceccafdcc94.mp4";